class WishlistDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#WishlistDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderWishlistIconAccessibility();
  }

  setHeaderWishlistIconAccessibility() {
    const wishlistLink = document.querySelector('#wishlist-icon-bubble');
    if (!wishlistLink) return;

    wishlistLink.setAttribute('role', 'button');
    wishlistLink.setAttribute('aria-haspopup', 'dialog');
    wishlistLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(wishlistLink);
    });
    wishlistLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(wishlistLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const wishlistDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (wishlistDrawerNote && !wishlistDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(wishlistDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('WishlistDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(wishlistDrawerNote) {
    wishlistDrawerNote.setAttribute('role', 'button');
    wishlistDrawerNote.setAttribute('aria-expanded', 'false');

    if (wishlistDrawerNote.nextElementSibling.getAttribute('id')) {
      wishlistDrawerNote.setAttribute('aria-controls', wishlistDrawerNote.nextElementSibling.id);
    }

    wishlistDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    wishlistDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#WishlistDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'wishlist-drawer',
        selector: '#WishlistDrawer',
      },
      {
        id: 'wishlist-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('wishlist-drawer', WishlistDrawer);

class WishlistDrawerItems extends WishlistItems {
  getSectionsToRender() {
    return [
      {
        id: 'WishlistDrawer',
        section: 'wishlist-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'wishlist-icon-bubble',
        section: 'wishlist-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('wishlist-drawer-items', WishlistDrawerItems);
